import React from 'react';
import { CheckCircleOutlined, UpCircleOutlined, DownCircleOutlined } from '@ant-design/icons';
import { UtilizationInventoryCard } from './UtilizationInventoryCard';
import { CustomSVG } from '../../CustomSVG/CustomSVG';
import StorageSvg from '../../../assets/icons/storage.svg?raw';
import {
    calculatePercentage,
    formatPercent,
    oversizedUndersizedState,
} from '../../SummaryWrapper/inventorySummaryHelpers';
import { formatCount, formatDecimal } from '../../../pages/Discovery/helpers';

export const StorageUtilizationCard = ({
    optimizedByStorage,
    totalInventory,
    totalStorage,
    storageReductionOpportunities,
    undersizedStorage,
    primaryTrend,
    oversizedTrend,
    undersizedTrend,
    isExpanded,
    ...props
}) => (
    <UtilizationInventoryCard
        title="Storage Utilization"
        subLabelIcon={<CheckCircleOutlined />}
        subLabelIconClass="success-icon"
        subLabel="Optimized VMs"
        primaryValue={formatCount(optimizedByStorage)}
        primaryPercent={formatPercent(calculatePercentage(optimizedByStorage, totalInventory))}
        primaryTrend={primaryTrend}
        description={'Instances meeting\nutilization thresholds'}
        rows={[
            {
                variant: 'ready',
                label: 'Total Storage',
                count: formatDecimal(totalStorage?.value ?? 0),
                countSuffix: totalStorage?.unit ?? 'GiB',
                icon: <CustomSVG svg={StorageSvg} />,
            },
            {
                variant: 'ready',
                label: 'Oversized VMs',
                count: formatCount(storageReductionOpportunities),
                percent: formatPercent(calculatePercentage(storageReductionOpportunities, totalInventory)),
                percentTrend: oversizedTrend,
                oversizedUndersizedState: oversizedUndersizedState(oversizedTrend),
                iconVariant: 'notReady',
                icon: <UpCircleOutlined />,
            },
            {
                variant: 'notReady',
                label: 'Undersized VMs',
                count: formatCount(undersizedStorage),
                percent: formatPercent(calculatePercentage(undersizedStorage, totalInventory)),
                percentTrend: undersizedTrend,
                oversizedUndersizedState: oversizedUndersizedState(undersizedTrend),
                icon: <DownCircleOutlined />,
            },
        ]}
        isExpanded={isExpanded}
        {...props}
    />
);
